module.exports = __webpack_public_path__ + "img/ring_r_l_1_1@3x.4cbf1c01.png";